import React from 'react';

import styles from './footer.module.css';
import FooterLinks from './footer-links/footer-links';
import Button from './footer-button/footer-button';
import { buttonOrAnchorProp } from './types';

type FooterProps = {
    buttonLabel: string;
    buttonProps?: buttonOrAnchorProp;
    showFooterLinks?: boolean;
};

const Footer = ({ buttonLabel, buttonProps, showFooterLinks = true }: FooterProps) => {
    return (
        <div className={styles.container}>
            {showFooterLinks && <FooterLinks />}
            <Button code={buttonLabel} buttonProps={buttonProps} />
        </div>
    );
};

export default Footer;
